<template>
	<div class="overflow-hidden">
		<v-app-bar 
			absolute
			color="#6A76AB"
			light
			hide-on-scroll
			scroll-target="#main_content"
			:src="require(`../assets/logo.png`)"
		>
			<v-toolbar-title>Привет, {{ user.first_name != '' ? user.first_name : user.username }}</v-toolbar-title>
			<v-spacer></v-spacer>

			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn icon to="/" v-on="on">
						<v-icon>mdi-home</v-icon>
					</v-btn>
				</template>
				<span>Главная</span>
			</v-tooltip>

			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn icon to="/dashboard/" v-on="on">
						<v-icon>mdi-view-module</v-icon>
					</v-btn>
				</template>
				<span>Проекты</span>
			</v-tooltip>

			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn icon @click="logOut" v-on="on">
						<v-icon>mdi-logout</v-icon>
					</v-btn>
				</template>
				<span>Выйти</span>
			</v-tooltip>
		</v-app-bar>
		<v-sheet id="main_content" class="overflow-y-auto grey lighten-5">
			<v-container style="min-height:100vh; padding-top:85px">
				<component :is="currentComponent"></component>
		</v-container>
		</v-sheet>
  </div>
</template>

<script>

import ProjectsList from '../components/Project/List'
import ProjectItem from '../components/Project/Item'
import StorageMixin from '../shared/StorageMixin'

export default {
	name: 'Dashboard',
	props: { data: { default:null } },
	components: { ProjectsList, ProjectItem },
	mixins: [ StorageMixin ],
	data: () => ({
		uploadDataTabName:"Управление данными", menuVisible:false, user:{},
		currentComponent:'ProjectItem'
	}),
	created(){
		this.getUserData()
		this.defineComponent(this.$route.name)
	},
	methods: {
		getUserData(){
			let requestUserData = new Promise((res, rej) => {
				this.$api.get('cp/', {
					data: {token:this.token},
				})
				.then(response => res(response))
				.catch(error => rej(error))
			})

			requestUserData
				.then(response => {
					this.user = response.data.user
				})
				.catch(error => {
					console.log('Error getting dashboard data, ', error)
					this.logOut()
				})
		},
		logOut(){
			this.$api.post('auth/logout/', {})
			.then(response => {
				this.$eventBus.$emit('user_log_out')
				this.$destroy()
			})
			.catch(error => error)
		},
		defineComponent(routeName){
			if(routeName === 'dashboard') this.currentComponent = 'ProjectsList'
			if(routeName === 'project') this.currentComponent = 'ProjectItem'
		}
	},
	watch: {
		'$route'(to, from){
			this.defineComponent(to.name)
		}
	}
}
</script>

<style lang="scss">
	@import '~vuetify/src/styles/styles.sass';
	.v-toolbar.v-toolbar--absolute { z-index:2!important }
	.v-toolbar__title img {
		display:block; width:200px;
		@media #{map-get($display-breakpoints, 'md-and-down')}{
			width:130px
		}
	}
	.v-toolbar__image .v-image__image.v-image__image--cover { background-position:center center!important; background-size:12%!important; background-color:#fff!important }
</style>